/* eslint-disable */
import { useCallback, useEffect, useState } from 'react';

// ============================================================
// useSavedViews — named filter presets per portal, per user, per browser.
// localStorage `clb.shell.views.<scope>.<userKey>` → [{ id, name, state, at }].
// The caller serialises its own state (Sets → arrays) and applies it back; the
// hook only stores and lists. Convention #143: the key is scoped per consumer.
// ============================================================

function keyFor(scope, userKey) { return `clb.shell.views.${scope}.${(userKey || 'anon').toLowerCase()}`; }
function read(key) { try { const v = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
function write(key, list) { try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* session only */ } }

export function useSavedViews(scope, userKey) {
  const key = keyFor(scope, userKey);
  const [list, setList] = useState(() => read(key));
  useEffect(() => { setList(read(key)); }, [key]);

  const save = useCallback((name, state) => {
    const id = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
    const next = [...read(key).filter((v) => v.name !== name), { id, name, state, at: new Date().toISOString() }];
    write(key, next); setList(next); return id;
  }, [key]);

  const remove = useCallback((id) => {
    const next = read(key).filter((v) => v.id !== id);
    write(key, next); setList(next);
  }, [key]);

  return { views: list, save, remove };
}

// Sets ↔ arrays for a filters object { axis: Set }.
export const serializeSets = (obj) => Object.fromEntries(Object.entries(obj || {}).map(([k, v]) => [k, v instanceof Set ? Array.from(v) : v]));
export const reviveSets = (obj) => Object.fromEntries(Object.entries(obj || {}).map(([k, v]) => [k, Array.isArray(v) ? new Set(v) : v]));
